
const InventoryPlanValidationErrorCode = {
    "LESS_THAN_WASTE_AMOUNT_ERROR" : "LESS_THAN_WASTE_AMOUNT_ERROR"
}

function prepareWasteAmountErrorPayload(data) {
    let items = {};
    for(const block of data) {
        const { moduleId, systemId, wasteAmount } = block;
        items[`${moduleId}-${systemId}`] = `Has to be more than ${wasteAmount}g`;
    }
    return items;
}

export function parseMetaData(data) {

    let erroredItemsMap = {};

    if(!(data.code in InventoryPlanValidationErrorCode)) {
        console.error("Could not find a valid error key to parse metadata");
    }

    switch(data.code) {
        case InventoryPlanValidationErrorCode.LESS_THAN_WASTE_AMOUNT_ERROR:
            erroredItemsMap = prepareWasteAmountErrorPayload(data.data);
            break;

        default:
            break;
    }

    return erroredItemsMap;
}